import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-14151582")

_pushScopeId("data-v-14151582")
const _hoisted_1 = { class: "flex-grow whitespace-nowrap" }
const _hoisted_2 = { class: "w-full py-3 bg-white" }
const _hoisted_3 = {
  "data-testid": "client-rate-bulk-download-list",
  class: "flex flex-col overflow-y-auto",
  style: {"max-height":"450px"}
}
const _hoisted_4 = { class: "col-span-3 flex space-x-3 items-center" }
const _hoisted_5 = { class: "col-span-2 flex items-center" }
const _hoisted_6 = { class: "text-12px text-gray-lp-800" }
const _hoisted_7 = { class: "text-12px text-gray-lp-800" }
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = { class: "flex items-center justify-center bg-white rounded-full border border-red-lp-100 w-5 h-5" }
const _hoisted_10 = { class: "text-xs" }
const _hoisted_11 = {
  key: 0,
  class: "px-4"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { id: "bulk-download-infinite-scroll" }, null, -1)
const _hoisted_14 = { class: "px-6 flex flex-col space-y-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", {
    "data-testid": "client-rate-bulk-download-widget",
    class: ["fixed w-fit z-20 bottom-0 right-0 flex flex-col rounded-t-lg", { 'pb-4': _ctx.isShowRunningText }],
    style: {"box-shadow":"0px 0px 15px rgba(26, 20, 33, 0.15)","width":"360px"}
  }, [
    _createVNode("div", {
      "data-testid": "client-rate-bulk-download-widget-toggle",
      class: "w-full px-6 py-3 text-white bg-red-lp-300 text-16px font-semibold space-x-6 flex items-center cursor-pointer rounded-t-lg",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onToggleMenu && _ctx.onToggleMenu(...args)))
    }, [
      _createVNode("span", _hoisted_1, _toDisplayString(_ctx.headerTitle), 1),
      (_ctx.isCloseable)
        ? (_openBlock(), _createBlock(_component_Icons, {
            key: 0,
            name: "close",
            class: "w-4 text-white",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode("img", {
        alt: "chevron",
        class: "w-5",
        src: 
          require(`@/app/ui/assets/svg/chevron-${
            _ctx.isOpen ? 'down' : 'up'
          }-white.svg`)
        
      }, null, 8, ["src"])
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.downloadRequestList, (group, index) => {
          return (_openBlock(), _createBlock(_Fragment, {
            key: `${index}`
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(group, (item, itemIndex) => {
              return (_openBlock(), _createBlock(_Fragment, {
                key: `${itemIndex}`
              }, [
                _withDirectives(_createVNode("div", { class: "pl-4 text-black-lp-300 font-semibold bg-gray-lp-200 text-12px" }, _toDisplayString(item.dateString), 513), [
                  [_vShow, itemIndex === 0]
                ]),
                _createVNode("div", {
                  "data-testid": `client-rate-bulk-download-row-${item.id}`,
                  class: ["px-4 grid grid-cols-5 space-x-2 items-center w-full item-hovered", itemIndex === group.length - 1 ? 'pt-4 pb-6' : 'py-4']
                }, [
                  _createVNode("div", _hoisted_4, [
                    _withDirectives(_createVNode("div", {
                      class: ["flex-grow min-w-0 truncate text-black-lp-300 text-14px", 
                    `${
                      item.title.length > 20 ? 'cursor-pointer' : 'cursor-default'
                    }`
                  ],
                      style: 
                    item.status === 'failed'
                      ? 'text-decoration: line-through;'
                      : ''
                  
                    }, [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ], 6), [
                      [
                        _directive_tooltip,
                        `${item.title.length > 20 ? item.title : ''}`,
                        void 0,
                        { bottom: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_5, [
                    (item.status === 'waiting')
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          "data-testid": `client-rate-bulk-download-state-waiting-${item.id}`,
                          class: "flex space-x-2 items-center cursor-wait"
                        }, [
                          _createVNode(_component_Icons, {
                            name: "refresh",
                            class: "w-5 text-gray-lp-800"
                          }),
                          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.generate")), 1)
                        ], 8, ["data-testid"]))
                      : (item.url === 'no-data')
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            "data-testid": `client-rate-bulk-download-state-no-data-${item.id}`,
                            class: "flex space-x-2 items-center cursor-default"
                          }, [
                            _createVNode("img", {
                              alt: "failed",
                              class: "w-5",
                              src: 
                      require(`@/app/ui/assets/svg/x-circle-outline-gray.svg`)
                    
                            }, null, 8, ["src"]),
                            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.dataNotFound")), 1)
                          ], 8, ["data-testid"]))
                        : (item.status === 'success' && item.url)
                          ? (_openBlock(), _createBlock("div", {
                              key: 2,
                              "data-testid": `client-rate-bulk-download-action-download-${item.id}`,
                              class: "flex space-x-2 items-center cursor-pointer text-green-lp-100",
                              onClick: ($event: any) => (_ctx.onDownload(item))
                            }, [
                              _createVNode(_component_Icons, {
                                name: "download-new",
                                class: "w-5"
                              }),
                              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.download")), 1)
                            ], 8, ["data-testid", "onClick"]))
                          : (_openBlock(), _createBlock("div", {
                              key: 3,
                              "data-testid": `client-rate-bulk-download-state-failed-${item.id}`,
                              class: "flex space-x-2 items-center cursor-default text-red-lp-100"
                            }, [
                              _createVNode("div", _hoisted_9, [
                                _createVNode(_component_Icons, {
                                  name: "close",
                                  class: "w-3"
                                })
                              ]),
                              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("clientManagement.infoPriceClient.failed")), 1)
                            ], 8, ["data-testid"]))
                  ])
                ], 10, ["data-testid"]),
                (Number(itemIndex) < group.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 64))
        }), 128)),
        _hoisted_13,
        _withDirectives(_createVNode("div", _hoisted_14, [
          _createVNode(_component_skeleton, {
            width: "100%",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            width: "90%",
            height: "20px"
          })
        ], 512), [
          [_vShow, _ctx.isLoading]
        ])
      ], 512), [
        [_vShow, _ctx.downloadRequestList.length]
      ])
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ], 2))
})